import { TestIdDomain } from 'constants/testIds';

const ConfirmationModalTestIdsScope = {
  CONFIRMATION_MODAL: 'confirmation-modal',
};

export const ConfirmationModalTestIds = {
  MODAL: `${TestIdDomain.DIALOGS}.${ConfirmationModalTestIdsScope.CONFIRMATION_MODAL}`,
  MESSAGE_LABEL: `${ConfirmationModalTestIdsScope.CONFIRMATION_MODAL}.message-label`,
  DESCRIPTION_LABEL: `${ConfirmationModalTestIdsScope.CONFIRMATION_MODAL}.description-label`,
  ACCEPT_BUTTON: `${ConfirmationModalTestIdsScope.CONFIRMATION_MODAL}.accept-button`,
  CANCEL_BUTTON: `${ConfirmationModalTestIdsScope.CONFIRMATION_MODAL}.cancel-button`,
};
